import ErrorPopup from '../../../../vendor_core/core/src/ui/popups/ErrorPopup';
import ViewManager from '../../../../vendor_core/core/src/utils/ViewManager';

export default class BBErrorPopup extends ErrorPopup {
    public show(callback?: Function) {
        super.show(callback);
        // show popup background
        ViewManager.getLayer("PopupsBackground").setScene("open");
    }

    public hide = () => {
        super.hide();
        // clear popup background
        ViewManager.getLayer("PopupsBackground").clear();
    }
}
